module.exports = __webpack_public_path__ + "img/loan.83b43120.png";